import TimeInput from "./time-input.js";
import snackbar from "./snackbar.js";

function createAddForm(el, refs, onSubmit, onDelete) {
    const nbsp = String.fromCharCode(160);

    const startTimeInput = new TimeInput({
        onBlur: () => {
            endTimeInput.minTime = startTimeInput.value;
            endTimeInput.value = TimeInput.nextHour(startTimeInput.value);
        },
    });

    const endTimeInput = new TimeInput({
        defaultValue: () => TimeInput.nextHour(startTimeInput.value),
        minTime: startTimeInput.value,
        onBlur: () => {
            if(startTimeInput.value.localeCompare(endTimeInput.value) > 0) {
                endTimeInput.value = endTimeInput.defaultValue();
            }
        },
    });

    const container =
        el("dialog", { ref: "addFormModal", class: "add-form-modal" }, [
            el("div", { class: "add-form-container" }, [
                el("div", { style: "display:flex" }, [
                    el("div", [
                        el("h1", { ref: "addFormRoomLabel", class: "add-form-room-label" }),
                        el("h2", { ref: "addFormDateLabel", class: "add-form-date-label" }),
                        el("p", { ref: "messageDisplay", class: "add-form-message-display" }),
                    ]),
                    el("button", { ref: "addFormCloseButton",class: "icon-button fill" }, [
                        el("svg", {
                            height: "800px",
                            width: "800px",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                        }, [
                            el("path", {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
                                fill: "#0F1729",
                            }),
                        ]),
                    ]),
                ]),
                el("ul", { ref: "reservationList", class: "reservation-list" }, [
                    el("li", "-- Empty --"),
                ]),
                el("form", { ref: "addForm", class: "add-form" }, [
                    el("input", { ref: "roomInput", type: "hidden" }),
                    el("input", { ref: "yearInput", type: "hidden" }),
                    el("input", { ref: "monthInput", type: "hidden" }),
                    el("input", { ref: "domInput", type: "hidden" }),
                    el("div", { class: "time-range-group" }, [
                        startTimeInput.root,
                        el("div", `${nbsp}-${nbsp}`),
                        endTimeInput.root,
                    ]),
                    el("textarea", { ref: "descriptionInput", placeholder: "Description...", }),
                    el("div", [
                        el("button", { ref: "addFormSubmitButton", type: "submit", class:  "main-button" }, "Save"),
                    ]),
                ]),
            ]),
        ]);

    refs.addFormCloseButton.addEventListener("click", () => {
        refs.addFormModal.close();
    });

    refs.descriptionInput.addEventListener("input", (event) => {
        if(event.target.value.length < 1) {
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = 'Description is required';
        } else {
            refs.messageDisplay.textContent = '';
        }
    });


    refs.addForm.addEventListener("submit", async (event) => {
        event.preventDefault();
        const description = refs.descriptionInput.value;

        if(typeof description !== "string" || description.length < 1) {
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = 'Description is required';
            return;
        }

        try {
            refs.messageDisplay.classList.add("primary");
            refs.messageDisplay.textContent = "Loading...";
            await onSubmit({
                roomId: refs.roomInput.value,
                year: refs.yearInput.value,
                month: refs.monthInput.value,
                dom: refs.domInput.value,
                startTime: startTimeInput.value,
                endTime: endTimeInput.value,
                description,
            });
            refs.descriptionInput.value = "";
            refs.addFormModal.close();
            snackbar.dispatch("Reservation saved", "primary", 3000);
        } catch(error) {
            refs.messageDisplay.classList.remove("primary");
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = `Error: ${error.message}`;
            setTimeout(() => {
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("error");
            }, 5000);
        } finally {
            if(refs.messageDisplay.classList.contains("primary")) {
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("primary");
            }
        }
    });

    refs.reservationList.addEventListener("click", async (event) => {
        event.preventDefault();
        const button = event.target.closest("button[data-id]");
        if(!button) {
            return;
        }

        const id = parseInt(button.dataset.id, 10);
        if(Number.isNaN(id)) {
            return;
        }

        try {
            refs.messageDisplay.classList.add("primary");
            refs.messageDisplay.textContent = "Loading...";
            await onDelete(id);
        } catch(error) {
            refs.messageDisplay.classList.remove("primary");
            refs.messageDisplay.classList.add("error");
            refs.messageDisplay.textContent = `Error: ${error.message}`;
            setTimeout(() => {
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("error");
            }, 5000);
        } finally {
            if(refs.messageDisplay.classList.contains("primary")) {
                refs.messageDisplay.textContent = "";
                refs.messageDisplay.classList.remove("primary");
            }
        }
    });


    return container;
}


export default createAddForm;
